import { gql } from "@apollo/client";

export const GET_NEWS_PROCESSOR_HEALTH = gql`
  query GetNewsProcessorHealth {
    newsProcessorHealth {
      status
      lastChecked
      responseTime
      error
      details
    }
  }
`;

export const REFRESH_NEWS_PROCESSOR_HEALTH = gql`
  mutation RefreshNewsProcessorHealth {
    refreshNewsProcessorHealth {
      status
      lastChecked
      responseTime
      error
      details
    }
  }
`;
